import { css } from 'emotion';

import { colors, fonts, icons } from '@cobliteam/base-components';

const transitionDuration = '0.3s';

export const tableStyle = css`
  table-layout: fixed;
`;

export const tableRow = css`
  && {
    height: 80px;
    cursor: pointer;

    :hover {
      background-color: ${colors.custom.accessory};
    }
  }
`;

export const chevron = (isOpen: boolean) => css`
  margin-left: auto;
  transform: rotate(${isOpen ? '90' : '-90'}deg);
  height: ${icons.size.small};
  color: ${colors.gray.dark};

  -webkit-transition: all ${transitionDuration} ease;
  -o-transition: all ${transitionDuration} ease;
  transition: all ${transitionDuration} ease;
`;

export const rowSeparator = css`
  && {
    height: 0;
    border-bottom: 1px solid ${colors.gray.light};

    :last-child {
      border-bottom: none;
    }
  }
`;

export const columnWithFixedWidth = (width: string) => css`
  min-width: ${width};
  max-width: ${width};
`;

export const totalCostCell = css`
  font-weight: ${fonts.weight.bold};
  color: ${colors.secondary.default};
`;
